import React from 'react';
import {VerticalSpacer} from '..';
import {CenteredGrid} from '../grid';
import Grid from '@material-ui/core/Grid';
import {CreatorFeedCard} from './card/CreatorFeedCard.molecule';
import {CreatorsFeedItemProps} from './CreatorFeed.organism';
import {AnimateOnViewWrap} from '../../wraps';
import {AccentColorProps} from 'epic-ue-theme';

export interface CreatorFeedProps {
    cards: CreatorsFeedItemProps[];
    alignItems?: 'flex-end' | 'flex-start';
    rowNum?: number;
}

const delay = 0.2;

export const CreatorFeedRow = ({
    cards = [],
    alignItems = 'flex-start',
    rowNum = 0,
    accentColor
}: CreatorFeedProps & AccentColorProps): JSX.Element => {
    return (
        <CenteredGrid alignItems={alignItems}>
            {cards.map((card, i) => {
                let square = i % 2 === 0;
                if (alignItems === 'flex-start') {
                    square = i % 2 !== 0;
                }

                const totalDelay = rowNum * delay + i * delay;

                return (
                    <Grid item md={4} key={card.title}>
                        <AnimateOnViewWrap translateY={40} delay={totalDelay}>
                            <CreatorFeedCard
                                {...card}
                                ratio={square ? 'square' : 'rect'}
                                accentColor={accentColor}
                            />
                        </AnimateOnViewWrap>
                        <VerticalSpacer variant="custom" spacing={9} />
                    </Grid>
                );
            })}
        </CenteredGrid>
    );
};
